"use client";
import Image from "next/image";
import React, { useEffect, useState } from "react";

const applianceData = [
  { UTILITY: "LAMP", WATTS: "100" },
  { UTILITY: "TUBE LIGHT", WATTS: "40" },
  { UTILITY: "REFRIGERATOR", WATTS: "200" },
  { UTILITY: "A/C WINDOW TYPE (1.5 ton)", WATTS: "1500-2000" },
  { UTILITY: "AIR COOLER (MEDIUM)", WATTS: "200" },
  { UTILITY: "ROOM COOLER", WATTS: "60-200" },
  { UTILITY: "FAN", WATTS: "60-100" },
  { UTILITY: "EXHAUST FAN", WATTS: "150" },
  { UTILITY: "ELECTRIC IRON", WATTS: "600-1000" },
  { UTILITY: "WATER HEATER", WATTS: "1500" },
  { UTILITY: "WATER GEYSER", WATTS: "1000-2000" },
  { UTILITY: "TOASTER", WATTS: "750" },
  { UTILITY: "ROOM HEATER (SIMPLE)", WATTS: "1000-2000" },
  { UTILITY: "ROOM HEATER (WITH FAN)", WATTS: "1000-2000" },
  { UTILITY: "WASHING MACHINE", WATTS: "700" },
  { UTILITY: "RADIO", WATTS: "40" },
  { UTILITY: "TV", WATTS: "200" },
  { UTILITY: "MIXER-GRINDER", WATTS: "200" },
  { UTILITY: "COMPUTER", WATTS: "200" },
  { UTILITY: "PUMP MOTOR", WATTS: "740" },
];


const EnergyCalculator = () => {
  const [appliances, setAppliances] = useState([]);
  const [totals, setTotals] = useState({ load: 0, units: 0 });

  useEffect(() => {
    const initialData = applianceData.map((item) => ({
      ...item,
      hours: 0,
      quantity: 0,
      units: 0,
    }));
    setAppliances(initialData);
  }, []);

  const handleChange = (index, field, value) => {
    const updated = [...appliances];

    // Let it stay as "" if user clears input
    updated[index][field] = value === "" ? "" : Number(value);

    let wattRange = updated[index].WATTS.split("-");
    let watt = parseFloat(wattRange[wattRange.length - 1]);

    const quantity = Number(updated[index].quantity) || 0;
    const hours = Number(updated[index].hours) || 0;

    const units = (watt * quantity * hours * 30) / 1000;
    updated[index].units = Math.round(units * 100) / 100;

    setAppliances(updated);

    const totalLoad = updated.reduce((acc, curr) => {
      let w = curr.WATTS.split("-");
      let watts = parseFloat(w[w.length - 1]);
      return acc + ((Number(curr.quantity) || 0) * watts);
    }, 0);

    const totalUnits = updated.reduce((acc, curr) => acc + (curr.units || 0), 0);
    setTotals({ load: Math.round(totalLoad), units: Math.round(totalUnits) });
  };



  return (
    <>
      <h1 className="text-center font-semibold text-xl lg:text-2xl md:font-medium lg:font-bold p-2 text-green-1 bg-[#ffffff] my-2 rounded-lg">
        Energy Calculator
      </h1>
      <main className="bg-green-3 bg-center min-[60%] rounded-lg py-10">
        <div className="xl:mx-16 mx-6">
          <div className="bg-white p-6 rounded-2xl shadow-md">
            <div className="flex justify-between items-center mb-6">
              <Image
                src="/assets/images/new_design/energy-calculator.webp"
                height={200}
                width={200}
                className="w-20 h-20 bg-green-12 md:ml-6 rounded-[50%] md:p-2"
                alt="Energy"
                sizes="(max-width: 640px) 80px, (max-width: 768px) 90px, 90px"
              />
              <div className="text-xl font-bold">
                <p className="font-bold text-base text-gray-800">
                  Total Connected Load:{" "}
                  <span className="text-green-2">{totals.load} W</span>
                </p>
                <p className="font-bold text-base text-gray-800">
                  Monthly Units (Approx):{" "}
                  <span className="text-green-2">{totals.units} kWh</span>
                </p>
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              {appliances.map((item, index) => (
                <div key={index} className="p-4 border rounded-lg bg-gray-50">
                  <div className="font-bold text-base my-3 text-green-12 text-center">
                    {item.UTILITY} ({item.WATTS}W)
                  </div>
                  <div className="mb-2">
                    <label className="block text-sm md:text-base md:font-semibold text-gray-800">
                      Average Usage (hrs/day)
                    </label>
                    <select
                      className="w-full border rounded p-2"
                      value={item.hours}
                      onChange={(e) =>
                        handleChange(index, "hours", e.target.value)
                      }
                    >
                      <option value="0">Hours</option>
                      {[...Array(24)].map((_, i) => (
                        <option key={i + 1} value={i + 1}>
                          {i + 1} hr
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="mb-2">
                    <label className="block text-sm md:text-base md:font-semibold text-gray-800">
                      Number of Appliances
                    </label>
                    <input
                      type="number"
                      className="w-full border rounded p-2"
                      value={item.quantity === "" ? "" : item.quantity} // ✅ keep blank if empty
                      onChange={(e) => handleChange(index, "quantity", e.target.value)}
                    />

                  </div>

                  <div className="font-medium text-gray-800 text-center">
                    Approx.Units/Month: {item.units}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default EnergyCalculator;
